import { gql } from "@apollo/client";

export const TheirInductionFragment = gql`
  fragment TheirInduction on Inductee {
    inducteeData {
      includeInductionSection
      inductionHero {
        headline
        type
        singleVideo {
          videoTitle
          videoType
          youtubeVideoId
          videoUrl
          previewVideoUrl
          videoThumbnail {
            ...ACFMedia
          }
          youtubeThumbnail {
            ...ACFMedia
          }
        }
        videoPlaylist {
          primaryVideo {
            performanceName
            videoType
            youtubeVideoId
            videoUrl
            previewVideoUrl
            videoThumbnail {
              ...ACFMedia
            }
            youtubeThumbnail {
              ...ACFMedia
            }
          }
          videos {
            performanceName
            videoType
            youtubeVideoId
            videoUrl
            videoThumbnail {
              ...ACFMedia
            }
            youtubeThumbnail {
              ...ACFMedia
            }
          }
        }
      }
      includeVideoCarousel
      inductionVideoCarousel {
        videos {
          title
          videoEmbed {
            videoType
            youtubeVideoId
            videoUrl
            videoThumbnail {
              ...ACFMedia
            }
            youtubeThumbnail {
              ...ACFMedia
            }
          }
        }
      }
      includeConnectedInductees
      connectedInductees {
        listType
        inductees {
          nodes {
            ... on Inductee {
              title
              uri
              ...PageData
            }
          }
        }
      }
    }
  }
`;
